'use client';
import React from 'react';

import * as format from '@/lib/format';
import * as Styled from './styled';
import { Row, Stack } from '@/ui/primatives';

type ProgressProps = {
  current: number;
  total: number;
  formatFunction?: (value: number) => string;
  currentFormatFunction?: (value: number) => string;
  totalFormatFunction?: (value: number) => string;
  showPercent?: boolean;
};

const defaultFormatFunction = (value: number) => value;

const ProgressIndicator: React.FC<React.HTMLAttributes<HTMLDivElement> & ProgressProps> = ({
  current,
  total,
  formatFunction = defaultFormatFunction,
  currentFormatFunction,
  totalFormatFunction,
  showPercent = true,
  ...rest
}) => {
  const percentCompleted = (current / total) * 100;
  const percentCompletedString = isNaN(percentCompleted) ? 'Waiting...' : `${Math.round(percentCompleted)}%`;

  return (
    <Styled.ProgressIndicator $progress={percentCompleted} {...rest}>
      <Stack gap={5}>
        <Row gap={20} justifyContent="space-between" alignItems="center">
          <div>{currentFormatFunction ? currentFormatFunction(current) : formatFunction(current)}</div>
          <div>{totalFormatFunction ? totalFormatFunction(total) : formatFunction(total)}</div>
        </Row>
        <div className="progress-bar">
          <div className="progress" style={{ width: `${percentCompleted}%` }} />
          {showPercent && (
            <>
              <div className="back">{percentCompletedString}</div>
              <div className="front">{percentCompletedString}</div>
            </>
          )}
        </div>
      </Stack>
    </Styled.ProgressIndicator>
  );
};

export default ProgressIndicator;
